import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Api from '@services/cabane.service';
import { textareaTextToArrayWithParams } from '@utils/utils';

export const fetch_cabane = createAsyncThunk(
  'about/fetch_cabane',
  async (_, thunkAPI) => {
    try {
      const response = await Api.get_cabane();
      return response.data;
    } catch {
      return '';
    }
  },
);
export const cabaneSlice = createSlice({
  name: 'cabane',
  initialState: {
    cabane: {},
    is_fetching_cabane: false,
  },
  reducers: {
    setBio: (state, action) => {
      state.cabane = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch_cabane.fulfilled, (state, action) => {
        let fetchedData = action.payload;
        if (Array.isArray(action.payload)) {
          fetchedData = fetchedData.map((item) => {
            return {
              id: item.id,
              slug: item.slug,
              ...item.acf,
              videos: textareaTextToArrayWithParams(item.acf.videos),
            };
          });
        }

        if (fetchedData.length === 0) {
          state.cabane = {};
          state.is_fetching_cabane = false;
          return;
        }

        state.cabane = fetchedData[0];
        state.is_fetching_cabane = false;
      })
      .addCase(fetch_cabane.pending, (state) => {
        state.is_fetching_cabane = true;
      });
  },
});

export const { setBio } = cabaneSlice.actions;

export default cabaneSlice.reducer;
